/* eslint-disable react/prop-types */
import React, { useState, useEffect, useContext, useRef } from "react"; //import the component part of React
import withRouter from "../WithRouter";
import FadeIn from "../common/FadeIn";
//Packages
import axios from "axios";
import { Container } from "react-bootstrap";
//Subcomponents
import ClassInfo from "./page-parts/ClassInfo";
//Loading
import LoadingSpinner from "../LoadingSpinner";
//Context
import { BusinessContextConsumer } from "../BusinessContext";

const InfoOnlyClassView = (props) => {
  // State
  const [classData, setClassData] = useState("");
  const prorationPrice = ""; // Set an empty string to not render on info only view.
  // Get the classID and context.
  const classid = props.params.classid;
  const BusinessContext = useContext(BusinessContextConsumer);
  const { businessID, currencySymbol } = BusinessContext;
  // ref the class ID
  const prevClassId = useRef(); //Reference the previous class ID to ensure new get request if it changes.
  // Get the class proration data if needed
  useEffect(async () => {
    prevClassId.current = classid; // Assign Refs Value to current load

    // Request the Class Data
    const classDataRequest = await axios.get(
      `/api/public_view/class_selected_plus/${businessID}/${classid}/`,
      {
        withCredentials: true,
      }
    );
    return setClassData(classDataRequest.data.classData);
  }, [classid]); // Run useEffect when the classID changes to get new class data.

  if (classData) {
    return (
      <FadeIn delay={250} duration={450}>
        <Container>
          <ClassInfo
            prorationPrice={prorationPrice}
            classData={classData}
            currencySymbol={currencySymbol}
            direction="/dashboard"
          />
        </Container>
      </FadeIn>
    );
  } else {
    return <LoadingSpinner />;
  }
};

//Export
export default withRouter(InfoOnlyClassView);
